module.exports = __webpack_public_path__ + "img/abapay.1a6a1c94.svg";